import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import publicStore from "./modules/publicStore";
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user,
        publicStore,
    },
});
